export const getDiscordInvitationUrlFromCode = (code: string) => {
  return `https://discord.gg/${code}`;
};
